module.exports = __webpack_public_path__ + "img/skeleton.b4a8feef.svg";